export const MATHEMATICS_SHEET = "https://docs.google.com/spreadsheets/d/1WhCrQE8VLpc9UKh9NkdIOnRG7Umf_0pD/edit#gid=1797930318";

export const PHYSICS_SHEET = "https://docs.google.com/spreadsheets/d/1IWs0v9QO070YC_xoO4n_rGAyUQcVpJL1/edit#gid=880959401";

export const CHEMESTRY_SHEET = "https://docs.google.com/spreadsheets/d/1v-Bm2kHaMOKAycdrAVj7uHTAK0rMQqSw/edit#gid=2122943822";
export const LANGUAGES_SHEET = "https://docs.google.com/spreadsheets/d/1eZubHqpl4R2D0qpP_hDbLTph15KrZiv5K7IwwLbhap8/edit#gid=0";
export const GDESCRIPTIVE_SHEET = "https://docs.google.com/spreadsheets/d/1LukCeGZ_2PeEtG51b1dzOugFcEK3Yv2w/edit#gid=2058393558";


export const MATHEMATICS_INVITE_LINKS = {
    "calculo-i": "https://discord.gg/xVWbmSCsXM",
    "calculo-ii": "https://discord.gg/dU73M9SJvf",
    "calculo-iii": "https://discord.gg/YQgvrr7vsH",
    "ecuaciones-diferenciales": "https://discord.gg/CaAatuextk",
    "algebra-lineal": "https://discord.gg/9XJbBAKJMm",
    "algebra-lineal-ii": "https://discord.gg/MGWJsZxBVE"
}

export const PHYSICS_INVITE_LINKS = {
    "fisica-i": "https://discord.gg/ddfzTzt4Xe",
    "fisica-ii": "https://discord.gg/S67YFZkPvh",
    "fisica-iii": "https://discord.gg/N8VHrm9CKf",
}

export const CHEMESTRY_INVITE_LINKS = {
    "quimica-i": "https://discord.gg/VH6XTfsFwB",
    "quimica-inorganica": "https://discord.gg/BygK8Vb3uJ",
    "quimica-organica": "https://discord.gg/wYXffGfRKk",
    "quimica-general": "https://discord.gg/7YeB2w6QsT",
    "quimica-varios": "https://discord.gg/BD498FvX84"
}

export const GDESCRIPTIVE_INVITE_LINKS = {
    "geometria-descriptiva": "https://discord.gg/snWrnP5tuS"
}

export const LANGUAGES_INVITE_LINKS = {
    "ingles": "https://discord.gg/MTuyhj6eCV",
    "frances": "https://discord.gg/C2HPHnTaAj"
}